import { getChartTitle, getSeriesName } from './trendChartutils'
import ReactECharts from "echarts-for-react";
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

const TrendBarChart = (props) => {

    const { data, timeAggType, currencySymbol, graphType } = props;
    const { t } = useTranslation();
    
    let trends = data?.data ?? []

    trends = trends.filter((trend) => trend.metadata.key === graphType)

    const timestamps = (timeAggType === "q")? data?.timestamps.map((item)=>item.replace("Q1", "-01-01").replace("Q2", "-04-01").replace("Q3", "-07-01").replace("Q4", "-10-01")) : data?.timestamps;

    let series = [];

    trends.forEach((trend) => {

        const curve = trend.metadata;

        const name = getSeriesName(curve, t)

        let s = {
            name: name,
            data: trend.values,
            type: 'bar',
        }

        series.push(s)

    })  

    const title = getChartTitle(graphType, t, currencySymbol)
    let options = {
        xAxis: {
            data: timestamps,
		},
		yAxis: {
        },
        grid: {
            left: '5%',
            right: '5%', 
            top: 5,
            bottom: 45
        },
		tooltip: {
            trigger: "axis",
			confine: true,
			valueFormatter: (value) =>
				typeof value == "number" ? value.toLocaleString(navigator.language,{
                    minimumFractionDigits:2,
                    maximumFractionDigits:2
                }) : value,
		},
		series,
        textStyle: {
            fontFamily: "Roboto, Helvetica, Arial, sans-serif" 
        },
	}
    if (series.length > 1) {
        options.legend = {
            show: true,
            bottom: 0,
        }
    } 
    

    return (
        <Stack>
            <Typography align="center" component="h2" variant="h6" color="primary" paddingTop={'25px'}>{title}</Typography>
            <ReactECharts option={options} />
        </Stack>
        
    )
}
 
export default TrendBarChart;